/**
 * Where a saved report export (AudTrl_DataTransfer.ExportRecipe) can be rebuilt from, or null when
 * it cannot. Shared by the header's Re-download and Data Transfer History's Regenerate Report.
 *
 * Built from dbSlug + reportId, NOT recipe.reportPath: reportPath is stored as "/reports/{slug}"
 * with no database slug, and the router's "/:dbSlug/*" route matches that with dbSlug="reports",
 * so DatabaseProvider fails to resolve a database named "reports" and redirects to
 * /select-database. Historical rows still hold that path — reportPath is legacy and unused here.
 *
 * The whole recipe travels, not just the filters: it also carries the render options (sort order,
 * grouping, QR, custom title, watermark) that decide what the file looks like. Recipes written
 * before those fields existed simply lack them, and the report page keeps its own defaults.
 */
export const getRegenerateTarget = (exportRecipe) => {
  if (!exportRecipe) return null;
  try {
    const r = typeof exportRecipe === 'string' ? JSON.parse(exportRecipe) : exportRecipe;
    if (!r?.dbSlug || !r?.reportId || !r?.format) return null;
    return { path: `/${r.dbSlug}/reports/${r.reportId}`, format: r.format, params: r.filterParams, recipe: r };
  } catch { return null; }
};

/** Router state ReportViewerPage reads to re-run and export. The nonce lets the same report re-export twice. */
export const regenerateState = (target) => ({
  autoExport: target.format,
  params: target.params,
  recipe: target.recipe,
  nonce: Date.now(),
});
